import type { ApiRequestFailure } from './apiRequestFailure';

// Diagnostic serializer for the search Honeybadger reports (not user-facing) --
// keeps the raw response body verbatim for debugging, unlike the user-facing
// apiRequestFailureToMessage.
export function searchApiFailureMessage(apiError: ApiRequestFailure): string {
  // On a dropped connection (and some empty-bodied error responses) there is no
  // body to report -- responseText is '' and responseJson is null, which would
  // otherwise serialize to the uninformative literal string "null". Fall back
  // to the errorState so the report still names the failure.
  return (
    apiError.responseText ||
    (apiError.responseJson !== null
      ? JSON.stringify(apiError.responseJson)
      : apiError.errorState)
  );
}
